// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__202ib","clinicsSelect":"TableHeading_clinicsSelect__1ZG_3"};